import { useQuery } from '@tanstack/react-query';
import { dashboardsGetMyDashboard } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useMyDashboard = () =>
  useQuery({
    queryFn: () => extractData(dashboardsGetMyDashboard()),
    queryKey: ['Dashboards', 'my'],
  });
